module.exports = __webpack_public_path__ + "static/media/received_2082239515483232.059a0a30.jpeg";